import React, { useEffect, useState } from 'react';
import { LIBRARY_APPROVE_MODULES } from '../store/rightsArray';

export function MultipleSectionCheckBox({ items, handleSelectAll, parentElement }) {
  const [element, setElement] = useState(items);
  const [readState, setReadState] = useState(false);
  useEffect(() => {
    setElement(items);
  }, [items]);

  const checkedHandler = (e, _element) => {
    handleSelectAll(e, _element);
    setReadState(!readState);
  };
  return (
    <tr>
      <td style={{ paddingLeft: '6.3%' }} />
      <td style={{ paddingLeft: '6.3%' }}>
        <div className="checkbox-label">
          <input
            onChange={(e) => {
              checkedHandler(e, element);
            }}
            name="all"
            id={`${element?.map((ele) => ele?.section.label)[0]}all`}
            type="checkbox"
            checked={element?.filter((val) => val?.all === true).length === element?.length}
          />
          <label htmlFor={`${element?.map((ele) => ele?.section.label)[0]}all`} className="chklabel" />
        </div>
      </td>
      <td style={{ paddingLeft: '6.3%' }}>
        <div className="checkbox-label">
          <input
            onChange={(e) => {
              checkedHandler(e, element);
            }}
            name="addEdit"
            id={`${element?.map((ele) => ele?.section.label)[0]}addEdit`}
            type="checkbox"
            checked={element?.filter((val) => val?.addEdit === true).length === element?.length}
          />
          <label htmlFor={`${element?.map((ele) => ele?.section.label)[0]}addEdit`} className="chklabel" />
        </div>
      </td>
      <td style={{ paddingLeft: '6.3%' }}>
        <div className="checkbox-label">
          <input
            onChange={(e) => {
              checkedHandler(e, element);
            }}
            name="delete"
            id={`${element?.map((ele) => ele?.section.label)[0]}delete`}
            type="checkbox"
            checked={element?.filter((val) => val?.delete === true).length === element?.length}
          />
          <label htmlFor={`${element?.map((ele) => ele?.section.label)[0]}delete`} className="chklabel" />
        </div>
      </td>
      {element.length === 1 && (
        <td style={{ paddingLeft: '6.3%' }}>
          {!element[0]?.all && !element[0]?.delete && !element[0]?.addEdit && (
            <div className="checkbox-label">
              <input
                name="read"
                id={`${element?.map((ele) => ele?.section.label)[0]}read`}
                type="checkbox"
                checked={element?.filter((val) => val?.read === true).length === element?.length}
              />
              <label htmlFor={`${element?.map((ele) => ele?.section.label)[0]}read`} className="chklabel" />
            </div>
          )}
        </td>
      )}

      <td style={{ paddingLeft: '6.3%' }} />
      {(parentElement?.name === 'products' || parentElement?.name === 'libraries') && (
        <td style={{ paddingLeft: '6.3%' }}>
          <div className="checkbox-label">
            <input
              onChange={(e) => {
                checkedHandler(e, element);
              }}
              name="approveReject"
              id={`${element?.map((ele) => ele?.section.label)[0]}approveReject`}
              type="checkbox"
              checked={
                parentElement?.name === 'products'
                  ? element?.filter((val) => val?.approveReject === true).length === element?.length
                  : element?.filter((val) => LIBRARY_APPROVE_MODULES.includes(val?.module)).every((val) => val?.approveReject === true)
              }
            />
            <label htmlFor={`${element?.map((ele) => ele?.section.label)[0]}approveReject`} className="chklabel" />
          </div>
        </td>
      )}
    </tr>
  );
}
